'use client'
import { logTrace } from '../Utilities/Logger';

const LocationPermissionGranted = async (navigator: Navigator, email: string): Promise<boolean> => {
    if (!navigator.geolocation) {
        logTrace(`Geolocation is not supported by this browser for ${email}.`);
        return false;
    }
    
    if ('permissions' in navigator && typeof (navigator as any).permissions?.query === 'function') {
            try {
                const status: PermissionStatus = await (navigator as any).permissions.query({ name: 'geolocation' as PermissionName });
                logTrace(`Geolocation permissions state for ${email}: ${status.state}`);
            
                if (status.state === 'granted' || status.state === 'prompt') return true;
                if (status.state === 'denied') return false;
            } catch (err) {
                logTrace(`Geolocation is not supported by this browser for ${email}.`)
            }
        }
    
    return false;    
};

export default LocationPermissionGranted;